import { render, staticRenderFns } from "./suggestedResourceTableV2.vue?vue&type=template&id=34b5a2e0&scoped=true"
import script from "./suggestedResourceTableV2.vue?vue&type=script&lang=ts"
export * from "./suggestedResourceTableV2.vue?vue&type=script&lang=ts"
import style0 from "./suggestedResourceTableV2.vue?vue&type=style&index=0&id=34b5a2e0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b5a2e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34b5a2e0')) {
      api.createRecord('34b5a2e0', component.options)
    } else {
      api.reload('34b5a2e0', component.options)
    }
    module.hot.accept("./suggestedResourceTableV2.vue?vue&type=template&id=34b5a2e0&scoped=true", function () {
      api.rerender('34b5a2e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/suggestedResourceTableV2.vue"
export default component.exports